document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function () {
      var details = link.closest('details');
      if (details) details.removeAttribute('open');
    });
  });
});// Mobile menu single-click fix
document.addEventListener('DOMContentLoaded', function () {
  var mobileMenu = document.querySelector('.mobile-menu');
  if (mobileMenu) {
    var summary = mobileMenu.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (mobileMenu.hasAttribute('open')) {
          mobileMenu.removeAttribute('open');
        } else {
          mobileMenu.setAttribute('open', '');
        }
      });
    }
  }
});

